.atm_vy_1ns9ob4{width:fit-content;}
.atm_kd_glywfm{outline:none;}
.atm_9s_1txwivl{display:flex;}
.atm_ar_1bp4okc.atm_ar_1bp4okc{flex-direction:column;}
.atm_cx_ftgil2{gap:8px;}
.atm_fc_1yb4nlp.atm_fc_1yb4nlp{justify-content:space-between;}
.atm_l8_zikty{padding:0px 16px;}
.atm_ks_1wugsn5{overflow:auto;}
.atm_l8_1fan3n7{padding:16px 16px 0px;}
.atm_9s_11p5wf0{display:grid;}
.atm_fc_h9n0ih.atm_fc_h9n0ih{justify-content:end;}
